import { useSearchParams } from 'react-router-dom';
import { PublicSigningPage } from './PublicSigningPage';

/**
 * A signer opening one document after another stays stuck on the "Document
 * signed" screen. Each document is a different `?token=` on the same route, and
 * React Router keeps the page mounted across that change, so the previous
 * document's signing state carries over. Keying by the token gives each
 * document a fresh page.
 */
export const PublicSigningRoute = () => {
	const [searchParams] = useSearchParams();
	const token = searchParams.get('token') ?? '';
	return <PublicSigningPage key={token} />;
};
